module.exports = "//static.hsappstatic.net/WebsiteGraderUI/static-1.1473/img/spinner.png"


//////////////////
// WEBPACK FOOTER
// ../node_modules/bender-webpack/lib/bender-url-loader.js!./img/spinner.png
// module id = 301
// module chunks = 0